import { createBrowserHistory } from "history";
import store from "../store";

const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});

const push = history.push;

history.push = (path, state, postFixParam) => {
  if (path?.indexOf('?') > -1) {
    push(`${path}${postFixParam}`, state)
  } else {
    push(`${path}${store.get().appStore.appQueryParam}`, state)
  }
}

export default history;
